import { stringToDate } from '@hc-frontend/utils'

export default function getPeriodRange(start: string) {
  const sDate = stringToDate(start)
  const startParts = sDate.toDateString().split(' ')

  return {
    slash: {
      start
    },
    monthName: {
      start: `${startParts[1]} ${+startParts[2]}, ${startParts[3]}`
    }
  }
}
